// enroll.js
import { delimiters } from '../shared/constants';
import { select } from '../shared/utils/dom';
import { getErrorMessages, getSuccessErrorSecondaryMessage } from './api';
import { createError, removeError } from '../shared/formErrors';
import { regex, isPasswordValid } from '../shared/constants/validation';
import multistepMixin from '../shared/vue/mixins/multistep';
import togglePassword from '../shared/vue/mixins/togglePassword';
import scrollUp from '../shared/vue/mixins/scrollUp';

const data = function () {
  return {
    modelEmail: null,
    modelConfirmEmail: null,
    // password
    modelPassword: null,
    // confirm password
    modelConfirmPassword: null,
    // password valid
    modelPasswordValid: false,
    // confirm password matches
    modelConfirmPasswordMatch: false,
    termsAgree: false,
    termsModalIsOpen: false,
    errorMessages: getErrorMessages(), // JSON.parse(document.getElementById('errors').innerHTML),
  }
}

const methods = {
  /**
   * Keyup on password field
   */
  keyUpPassword(event) {
    // password validity check
    if (event.target === this.$refs.password) {
      if (this.modelPassword && this.modelPassword.length < 8) {
        this.modelPasswordValid = false;
      } else if (!isPasswordValid(this.$refs.password.value)) {
        this.modelPasswordValid = false;
      } else {
        this.modelPasswordValid = true;
      }
    }

    // confirm password validity check
    if (event.target === this.$refs.confirmPassword) {
      // check they are the same thing
      if (this.modelConfirmPassword && this.modelPassword && this.modelPasswordValid && this.modelConfirmPassword === this.modelPassword) {
        this.modelConfirmPasswordMatch = true
        removeError(this.$refs.password, this.$refs.passwordError);
      } else {
        this.modelConfirmPasswordMatch = false
        removeError(this.$refs.confirmPassword, this.$refs.confirmPasswordError);
      }
    }
  },

  submitForm(event) {
    let hasError = false;

    // validate email
    if (!this.modelEmail) {
      createError(this.$refs.email, this.$refs.emailError, 'Please provide an email address.');
      hasError = true
    } else if (!regex.email.test(this.modelEmail)) {
      createError(this.$refs.email, this.$refs.emailError, getSuccessErrorSecondaryMessage(this.errorMessages, this.$refs.email.dataset.key));
      hasError = true
    } else {
      removeError(this.$refs.email, this.$refs.emailError);
    }
    // validate confirm email
    if (this.modelEmail.toLowerCase() !== this.modelConfirmEmail.toLowerCase()) {
      createError(this.$refs.confirmEmail, this.$refs.confirmEmailError, getSuccessErrorSecondaryMessage(this.errorMessages, this.$refs.confirmEmail.dataset.key));
      hasError = true
    } else {
      removeError(this.$refs.confirmEmail, this.$refs.confirmEmailError)
    }

    // validate password fields
    if (!this.modelPassword) {
      createError(this.$refs.password, this.$refs.passwordError, 'Please provide a password.');
      hasError = true
    } else if (!isPasswordValid(this.$refs.password.value)) {
      createError(this.$refs.password, this.$refs.passwordError, getSuccessErrorSecondaryMessage(this.errorMessages, this.$refs.password.dataset.key));
      hasError = true
    } else {
      removeError(this.$refs.password, this.$refs.passwordError);
    }
    // validate confirm password field
    if (!this.modelConfirmPassword) {
      createError(this.$refs.confirmPassword, this.$refs.confirmPasswordError, 'Please confirm password.');
      hasError = true
    } else if (this.modelPassword !== this.modelConfirmPassword) {
      createError(this.$refs.confirmPassword, this.$refs.confirmPasswordError, getSuccessErrorSecondaryMessage(this.errorMessages, this.$refs.confirmPassword.dataset.key));
      hasError = true
    } else {
      removeError(this.$refs.confirmPassword, this.$refs.confirmPasswordError);
    }

    if (hasError) {
      event.preventDefault();
    } else {
      // Show loading!
      this.loading = true;
      this.hidePasswordText();
    }
  },
}

/**
 * Migrating legacy account
 */
export default function migrateAccount() {
  const el = select('[data-vue-app="migrate-account"]');

  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      data,
      methods,
      mixins: [multistepMixin, scrollUp, togglePassword],
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/migrateAccount.js